import { AuthProject, AuthResponse, Organization, User } from "../models/user";

export const LOGIN = '[AUTH] Login';
export const ACCOUNT = '[AUTH] Account';
export const AGENTS_AVAILABLE = '[AUTH] Agents available';
export const ROLES_AVAILABLE = '[AUTH] Roles available';
export const LOGOUT = '[AUTH] Log Out';
export const SELECT_CLIENT = '[AUTH] Select client';
export const SELECT_PROJECT = '[AUTH] Select project';

export class LoginToken {
  static readonly type = LOGIN;
  constructor(public token: string){}
}

export class AccountAction {
  static readonly type = ACCOUNT;
  constructor(public payload: AuthResponse) {}
}

export class AgentsAvailable {
  static readonly type = AGENTS_AVAILABLE;
  constructor(public agents: string[]){}
}

export class RolesAvailable {
  static readonly type = ROLES_AVAILABLE;
  constructor(public roles: string[]){}
}

export class LogOut {
  static readonly type = LOGOUT;
}

export class SelectClient {
  static readonly type = SELECT_CLIENT;
  constructor(public selectedClient: Organization){}
}
export class SelectProject {
  static readonly type = SELECT_PROJECT;
  constructor(public selectedProject: AuthProject){}
}
